<template>
<v-container fluid class="weaver-plans">
    <v-container grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12 sm12 md4>
                <v-card style="border-radius:25px 25px 0px 0px;background: #2d2f31;margin-top:20px">
                    <v-layout style="height:500px;background:#2d2f31;margin:0px;border-style:solid;border-color:#2d2f31;border-width:15px;">
                        <v-img center src="~@/assets/images/fast_norm.png" style="border-style:solid;border-color:#86af49;border-width:10px;border-radius:25px"/>
                    </v-layout>
                    <v-card-title style="background:#EEEEEE" primary-title>

                        <div style="min-height:450px;">
                            <h3 class="headline mb-0">Weaver is Fast</h3>
                            <div>
                            <br/>
                            Weaver's motto is 'Just Talk' and we mean it. It only takes three taps to start communicating with people from around the globe.
                            <br/>
                            <br/>
                            All you need to start is a name, it doesn't need to be unique and if you can't think of one there's always the random name generator. 
                            <br/>
                            <br/>
                            From there create a channel with any name or join an existing one. No further set up is required just pick a channel name and go.
                            </div>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md4>
                <v-card style="border-radius:25px 25px 0px 0px;background: #2d2f31;margin-top:20px">
                    <v-layout style="height:500px;background:#2d2f31;margin:0px;border-style:solid;border-color:#2d2f31;border-width:15px;">
                        <v-img center src="~@/assets/images/location_norm.png" style="border-style:solid;border-color:#86af49;border-width:10px;border-radius:25px"/>
                    </v-layout>
                    <v-card-title style="background:#EEEEEE"  primary-title>
                        <div style="min-height:450px;">
                            <h3 class="headline mb-0">Weaver is Location Based</h3>
                            <div>
                            <br/>
                            Communicate with people nearby with location channels perfect for venue based communication.
                            <br/>
                            <br/>
                            Simply select join location channel and choose between short, medium and long range.
                            <br/>
                            <br/>
                            Or create a named channel with the event name, there's no limit to the number you can create.
                            </div>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md4>
                <v-card style="border-radius:25px 25px 0px 0px;background: #2d2f31;margin-top:20px">
                    <v-layout style="height:500px;background:#2d2f31;margin:0px;border-style:solid;border-color:#2d2f31;border-width:15px;">
                        <v-img center src="~@/assets/images/features_norm.png" style="border-style:solid;border-color:#86af49;border-width:10px;border-radius:25px"/>
                    </v-layout>
                    <v-card-title style="background:#EEEEEE" primary-title>
                        <div style="min-height:450px;">
                            <h3 class="headline mb-0">Weaver is Feature Rich</h3>
                            <div>
                                <br/>
                            Registered Users can rank up to unlock a plethora of other features including:
                            <br/>
                            <br/>
                            Private Channels,
                            Inboxing,
                            Mod and Admin roles,
                            Pinned Messages,
                            Channel Shouts,
                            Member Pings,
                            Custom Backgrounds,
                            Reserved VIP Names,
                            Dev channel Access,
                            Channel Promoting.
                            <br/>
                            <br/>
                            Plus many more on the way from our active dev team.
                            </div>
                        </div>
                    </v-card-title>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    </v-container>
</template>

<script>
export default {
    name: 'WeaverPlans',
    data () {
        return {
            key: 'value',
        }
    }
};

</script>

<style scoped>
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
  font-weight: normal
}
.weaver-plans {
    background: #222222;
    width: 100%;
    padding-top: 100px;
}
</style>